import React from 'react';
import styled from 'styled-components';
import { type ST, SandTableType } from '@types';
import ImgMap from './img-map.png';
import ImgMapM from './img-map-m.png';
import ImgImg from './img-img.png';
import ImgImgM from './img-img-m.png';

interface Props {
  data: ST;
}

const Icon = styled.img.attrs({
  draggable: 'false',
})`
  position: absolute;
  top: 4px;
  left: 4px;
  width: 26px;
  height: 16px;
`;

const IconM = styled(Icon)`
  width: 38px;
`;

function TypeMark({ data }: Props) {
  const { type, markers } = data;
  const isMarked = markers.length > 0;

  if (type === SandTableType.map)
    return isMarked ? <IconM src={ImgMapM} /> : <Icon src={ImgMap} />;
  if (type === SandTableType.image || SandTableType.matrix)
    return isMarked ? <IconM src={ImgImgM} /> : <Icon src={ImgImg} />;

  return null;
}

export default TypeMark;
